export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/Guest/Desktop/meme/src/environments/environment.ts